module.exports = __webpack_public_path__ + "img/1440539088.03eb5b1b.jpg";